import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Loader from '../../../assets/components/loader';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleQuestion,
  faCopy } from '@fortawesome/free-solid-svg-icons';
import { faShare } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

import {
  getCustomerId,
  getVirtualSpaces,
  openModal,
  closeModal,
  updateInstance
} from "../../../store/actions";

import InstanceModal from './instanceModal';
import MySpacesSkeleton from './mySpacesSkeleton';

const MyVirtualSpaces = (props) => {

  const dispatch = useDispatch();
  const virtualSpacesInfo = useSelector((state) => state.virtualSpaces);

  const [instance, setInstance] = useState({});

  useEffect(() => {
    if (!virtualSpacesInfo.userObtained){
      dispatch(getCustomerId());
    }
  }, [virtualSpacesInfo.userObtained])

  useEffect(() => {
    if (!virtualSpacesInfo.instancesObtained && virtualSpacesInfo.userEmail !== "") {
      dispatch(getVirtualSpaces(virtualSpacesInfo.userEmail));
    }
  }, [virtualSpacesInfo.userEmail])

  const editInstance = (instance) => {
    setInstance(instance);
    dispatch(openModal())
  }

  const  redirectInstance = (url) => {
    url = process.env.REACT_APP_URL_DOMAIN_NAME === `app` ? url : url.replace("app", "dev");
    window.open(`https://${url}/administrator`, '_blank')
  }

  if (!virtualSpacesInfo.loadedFirstTime) {
    return (
      <MySpacesSkeleton/>
    )
  }

  window.addEventListener('popstate', () => { dispatch(closeModal()) });

  return (
    <>
      <div className="virtual--spaces">
        <div className='instance--container'>
          {
            virtualSpacesInfo && virtualSpacesInfo.virtualSpaces && virtualSpacesInfo.virtualSpaces.length > 0 ?
              virtualSpacesInfo.virtualSpaces.map((it, i) => (
                <div key={i} className="instance--card">
                  <div>
                    <div className="instance--number">
                      {i + 1}
                    </div>
                  </div>
                  <div>
                    <div className="instance--header">
                      <div>
                        <p className="instance--title">
                          {it.name}
                          <span className="instance--date">{` Created on ${it.createdAt.split(" ")[0]}`}</span>
                        </p>
                      </div>
                      <div className="instance--buttons">
                        <button className="custom--button" onClick={ev => editInstance(it)}>Edit</button>
                        <button className="custom--button custom--button--marquet" onClick={ev => redirectInstance(it.urls.admin)}>Access</button>
                      </div>
                    </div>
                    <div className="instace--url">{process.env.REACT_APP_URL_DOMAIN_NAME === `dev` ? `${it.urls.admin.replace("app", "dev")}` : `${it.urls.admin}`}</div>
                    <div className="instance--description">{it.description}</div>
                  </div>
                </div>
              )):
              <div className="instance--card">
                <div className="no--instance">
                  <p>
                    It looks like you dont have any virtual spaces.
                  </p>
                </div>
              </div>
          }
        </div>
      </div>
      {virtualSpacesInfo && virtualSpacesInfo.modalOn && virtualSpacesInfo.modalOn === true &&
        <InstanceModal
          changeModalState={ev => dispatch(closeModal())}
          instance={instance}
          loading={virtualSpacesInfo.loading}
        />
      }
    </>
  )
}

export default MyVirtualSpaces;